// User action Type
export const SET_REPORT_DETAILS = "SET_REPORT_DETAILS";
